import { render, staticRenderFns } from "./EditLicense.vue?vue&type=template&id=8309c2ee&scoped=true&"
import script from "./EditLicense.vue?vue&type=script&lang=ts&"
export * from "./EditLicense.vue?vue&type=script&lang=ts&"
import style0 from "./EditLicense.vue?vue&type=style&index=0&id=8309c2ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8309c2ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
